import { createElement } from 'react';
import { render } from '../../libs/ngsModuleLoader';
import Translator from '../Translator';
import { isStoriesActive } from './checkIfStoriesActive';
import { tryInsertStoriesIntoDOM, createStoriesContainer } from './createStoriesContainer';
import { STORYLY_SUPPORTED_PAGES, DESKTOP_TITLE, DESKTOP_DESC } from './consts';

const getConsole = () => window.consoleReference || window.console;

const getLocale = () => Translator.getLocale();

const renderStories = (type) => {
    import('@sb/stories').then( Stories => {

        const container = createStoriesContainer();
        const isInserted = tryInsertStoriesIntoDOM(type, container);
        if (!isInserted) {
            getConsole().warn('Stories container incorrectly inserted into DOM');
            return;
        }

        const locale = getLocale();

        try {
            render(container, { uiKit: true }, ({ device }) => {
                return createElement(Stories.default, {
                    locale,
                    device,
                    ifSquaredStories: type === STORYLY_SUPPORTED_PAGES.FOOTBALL_MAIN_PAGE,
                    pathnameSegment: type,
                    desktopTitle: DESKTOP_TITLE,
                    desktopDescription: DESKTOP_DESC,
                }, null);
            });
        } catch(e) {
            getConsole().error('Error with Stories ',e);
        }
    });
};

export const tryRenderStories = (type) => {
    
    if(!isStoriesActive()){
        return;
    }

    if (window && window.WH && window.WH.messageBus && window.WH.messageBus.publish) {
        window.WH.messageBus.publish('sb.featureFlag.getFeatureFlag', {
            featureKey: 'storyly_stories_desktop_homepage',
            callback: (featureFlag) => {
                if (featureFlag.isEnabled) {
                    renderStories(type);
                }
            },
        });
    }
};
